<script>
  import { _ } from "svelte-i18n";

  export let duration = "";
  export let strengthType = "";
  export let focus = undefined;
  export let method = "";
  export let visible = true;

  const strengthOptions = [
    {
      category: "upperBody",
      label: $_("sessions.form.strength.upperBody"),
      options: [
        { value: "upperBody-endurance", label: $_("sessions.form.strength.endurance"), },
        { value: "upperBody-hypertrophy", label: $_("sessions.form.strength.hypertrophy"), },
        { value: "upperBody-maximal", label: $_("sessions.form.strength.maximal"), },
        { value: "upperBody-explosive", label: $_("sessions.form.strength.explosive"), },
      ]
    },
    {
      category: "lowerBody",
      label: $_("sessions.form.strength.lowerBody"),
      options: [
        { value: "lowerBody-endurance", label: $_("sessions.form.strength.endurance"), },
        { value: "lowerBody-hypertrophy", label: $_("sessions.form.strength.hypertrophy"), },
        { value: "lowerBody-maximal", label: $_("sessions.form.strength.maximal"), },
        { value: "lowerBody-explosive", label: $_("sessions.form.strength.explosive"), },
      ]
    },
    { value: "plyometrics", label: $_("sessions.form.strength.plyometrics") },
    { value: "speed", label: $_("sessions.form.strength.speed") },
  ];

  // Default value logic
  if (!strengthType && strengthOptions.length > 0) {
    if (strengthOptions[0].options && strengthOptions[0].options.length > 0) {
      strengthType = strengthOptions[0].options[0].value;
    } else if (strengthOptions[0].value) {
      strengthType = strengthOptions[0].value;
    }
  }

  // Update focus and method when strengthType changes
  $: if (strengthType) {
    if (strengthType.includes('-')) {
      const [category, type] = strengthType.split('-');
      focus = category === 'upperBody' ? 'upperBody' : 'lowerBody';
      method = type; // Just the type, not the full value
    } else {
      focus = undefined; // undefined for spring and speed
      method = strengthType; // Just the type
    }
  }

  function remove() {
    visible = false;
    strengthType = "removed";
    duration = "removed";
  }

  // getDisplayValue function updated to handle new structure
  function getDisplayValue() {
    if (!strengthType) return "";
    const [category, type] = strengthType.split("-");
    if (category && type) {
      const categoryLabel = category === "upperBody" ? $_("sessions.form.strength.upperBody") : $_("sessions.form.strength.lowerBody");
      const typeLabel = $_("sessions.form.strength." + type);
      return `${categoryLabel} - ${typeLabel}`;
    } else {
      return $_("sessions.form.strength." + strengthType);
    }
  }
</script>

{#if visible}
  <div class="form-subsection">
    <button
      type="button"
      on:click={remove}
      class="form-subsection__button-remove"
    >
    </button>

    <div class="">
      <label class="select" for="strength-type">
        <span class="select__label">
          {$_("sessions.form.strength.title")}
          {#if strengthType && strengthType.includes('-')}
            {#if strengthType.startsWith('upperBody')}
              ({$_("sessions.form.strength.upperBody")})
            {:else if strengthType.startsWith('lowerBody')}
              ({$_("sessions.form.strength.lowerBody")})
            {/if}
          {/if}
        </span>
        <span class="select__button">
          <select bind:value={strengthType}>
            <optgroup label={$_("sessions.form.strength.upperBody")}>
              {#each strengthOptions[0].options as option}
                <option value={option.value}>{option.label}</option>
              {/each}
            </optgroup>
            <optgroup label={$_("sessions.form.strength.lowerBody")}>
              {#each strengthOptions[1].options as option}
                <option value={option.value}>{option.label}</option>
              {/each}
            </optgroup>
            <option value={strengthOptions[2].value}>{strengthOptions[2].label}</option>
            <option value={strengthOptions[3].value}>{strengthOptions[3].label}</option>
          </select>
        </span>

      </label>

      <div class="form-group">
        <label class="input" for="strength-duration">
          <span class="input__label"
            >{$_("sessions.form.strength.duration")}</span
          >
          <input
            id="strength-duration"
            type="text"
            bind:value={duration}
            placeholder=""
            class="input__text input__text--size-sm"
            inputmode="numeric"
            maxlength="15"
            pattern="[0-9,]*"
            autocomplete="off"
          />
        </label>
      </div>
    </div>
  </div>
{/if}
